import { useMemo } from 'react'

import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'
import { useQuery } from '@percent/utility'

export function useRegistryLookup(countryCode: string) {
  const { nonprofitsService } = useServices()

  const { data, isLoading } = useQuery(
    ['getRegistries', countryCode],
    nonprofitsService.getRegistries,
    { countryCode, supportedTypes: ['nonprofit'] },
    { enabled: !!countryCode }
  )

  const registryOptions = useMemo(
    () => (data ?? []).map((r: { name: string; englishName: string }) => ({ value: r.name, label: r.englishName })),
    [data]
  )

  return { registryOptions, isRegistryLoading: isLoading }
}
